import { render, staticRenderFns } from "./DevBlogIntro.vue?vue&type=template&id=389e69cc&scoped=true&"
var script = {}
import style0 from "./DevBlogIntro.vue?vue&type=style&index=0&id=389e69cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e69cc",
  null
  
)

export default component.exports